<template>
  <TipTap
    :content.sync="content"
    :style-settings="styleSettings"
    iframe-extension
    mention-extension
    image-extension
    bubbles-legends-extension
    index-table-extension
  />
</template>

<script lang="ts">
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import TTMixin from '@/components/TipTap/wrappers/TTMixin'

const components = {
  TipTap,
}

@Component({ components })
export default class TTEditor extends TTMixin {
  showParent = false;

  get storySettings () {
    return this.$typedStore.primary.app.config.storySettings
  }

  get styleSettings () {
    return {
      // @ts-ignore TODO more issues with this.panel typing
      fontFamily: this.storySettings[this.panel].fontFamily,
      fontSize: 100,
    }
  }

  get defaultStoryPathToEdit () {
    return this.$typedStore.public.display.defaultStoryPathToEdit
  }
}
</script>
